const Loading = {
    open() {
        const div = document.createElement('div');
        div.className = "loading-mask";
        div.innerHTML = `<div class="spinner">
          <div class="spinner-container container1">
            <div class="circle1"></div>
            <div class="circle2"></div>
            <div class="circle3"></div>
            <div class="circle4"></div>
          </div>
          <div class="spinner-container container2">
            <div class="circle1"></div>
            <div class="circle2"></div>
            <div class="circle3"></div>
            <div class="circle4"></div>
          </div>
          <div class="spinner-container container3">
            <div class="circle1"></div>
            <div class="circle2"></div>
            <div class="circle3"></div>
            <div class="circle4"></div>
          </div>
        </div>`;
        document.body.appendChild(div);
    },
    hide() {
        document.querySelector('.loading-mask').remove();
    }
};

export default Loading;